// The one button. Variants and sizes map onto the .btn classes in site-ui.css (heights: xs 24, sm 28, md 32, lg 40).
// Use buttonClass() for links and router <Link>s that should look like a button. `link` is the text link: brand blue,
// underlined 3px under the letters, no box (so no size); it goes somewhere, where tertiary does something.

import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'secondary' | 'primary' | 'ghost' | 'danger' | 'danger-ghost' | 'tertiary' | 'link';
export type ButtonSize = 'xs' | 'sm' | 'md' | 'lg';

const VARIANT: Record<ButtonVariant, string> = {
  secondary: '',
  primary: 'btn-primary',
  ghost: 'btn-ghost',
  danger: 'btn-danger-solid',
  'danger-ghost': 'btn-ghost-danger',
  tertiary: 'btn-tertiary',
  link: 'btn-link',
};
const SIZE: Record<ButtonSize, string> = { xs: 'btn-xs', sm: 'btn-sm', md: '', lg: 'btn-lg' };

export function buttonClass(variant: ButtonVariant = 'secondary', size: ButtonSize = 'md', extra?: string) {
  if (variant === 'link') return ['btn-link', extra].filter(Boolean).join(' ');
  return ['btn', VARIANT[variant], SIZE[size], extra].filter(Boolean).join(' ');
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** A 16px Tabler icon, drawn before the label. */
  icon?: ReactNode;
}

export function Button({ variant = 'secondary', size = 'md', icon, className, type = 'button', children, ...rest }: ButtonProps) {
  return (
    <button type={type} className={buttonClass(variant, size, className)} {...rest}>
      {icon}
      {children}
    </button>
  );
}
